import apiClient from "./api";
import { SecretRequest, RequestsListResponse } from "@app-types/tap-partner-vault";

const CREDENTIALS_ENDPOINT = "/api/credentials";
const REQUESTS_ENDPOINT = "/api/requests";

export const requestsService = {
  /** Submit an access request for a credential */
  async createRequest(credentialId: string, note?: string): Promise<SecretRequest> {
    const response = await apiClient.post<SecretRequest>(
      `${CREDENTIALS_ENDPOINT}/${credentialId}/request`,
      { request_note: note }
    );
    return response.data;
  },

  /** Get the calling user's most recent request status for a credential (for polling) */
  async getMyRequestStatus(credentialId: string): Promise<SecretRequest | null> {
    const response = await apiClient.get<SecretRequest | null>(
      `${CREDENTIALS_ENDPOINT}/${credentialId}/request-status`
    );
    return response.data;
  },

  /** List all requests (admin/superadmin only). Optional status filter. */
  async listRequests(status?: string): Promise<SecretRequest[]> {
    const params = status ? `?status=${status}` : "";
    const response = await apiClient.get<RequestsListResponse>(
      `${REQUESTS_ENDPOINT}${params}`
    );
    return response.data.requests;
  },

  /** Get pending request count for the header badge (admin/superadmin only) */
  async getPendingCount(): Promise<number> {
    const response = await apiClient.get<{ count: number }>(
      `${REQUESTS_ENDPOINT}/pending-count`
    );
    return response.data.count;
  },

  /** Approve a request */
  async approveRequest(id: string, note?: string): Promise<SecretRequest> {
    const response = await apiClient.put<SecretRequest>(
      `${REQUESTS_ENDPOINT}/${id}/approve`,
      { review_note: note }
    );
    return response.data;
  },

  /** Deny a request */
  async denyRequest(id: string, note?: string): Promise<SecretRequest> {
    const response = await apiClient.put<SecretRequest>(
      `${REQUESTS_ENDPOINT}/${id}/deny`,
      { review_note: note }
    );
    return response.data;
  },
};
